import { EARLY_SOLVER_BONUS, EARLY_SOLVER_COUNT, MAX_GUESSES, SOLVE_POINTS } from "../_logic/constants";
import { STATUS_CLASSES } from "./tileStyles";

const EXAMPLES = [
  { letter: "G", status: "correct", text: "is in the word and in the right spot" },
  { letter: "U", status: "present", text: "is in the word but in the wrong spot" },
  { letter: "M", status: "absent", text: "isn't in the word" },
] as const;

/**
 * How to play and how points are earned.
 * @returns The rules block.
 */
export function WordleRules() {
  return (
    <div className="flex flex-col gap-4 text-left">
      <div className="flex flex-col gap-2">
        <h3 className="text-sm font-semibold text-slate-900">How to play</h3>
        <p className="text-sm font-medium text-slate-600">
          Guess the 5-letter word in {MAX_GUESSES} tries. The clock starts when you hit start.
        </p>
        <ul className="flex flex-col gap-2">
          {EXAMPLES.map(({ letter, status, text }) => (
            <li key={letter} className="flex items-center gap-3 text-sm font-medium text-slate-600">
              <span
                className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-md border-2 text-sm font-bold ${STATUS_CLASSES[status]}`}
              >
                {letter}
              </span>
              {text}
            </li>
          ))}
        </ul>
      </div>
      <div className="flex flex-col gap-2">
        <h3 className="text-sm font-semibold text-slate-900">Points</h3>
        <ul className="flex flex-col gap-1 text-sm font-medium text-slate-600">
          <li>
            <span className="font-semibold text-slate-900">{SOLVE_POINTS} pts</span> for solving
          </li>
          <li>
            <span className="font-semibold text-slate-900">+{EARLY_SOLVER_BONUS} pts</span> if you&apos;re one of the
            first {EARLY_SOLVER_COUNT} solvers today
          </li>
          <li>
            <span className="font-semibold text-slate-900">+1 pt</span> for every day in your streak, added to the
            Friday leaderboard
          </li>
        </ul>
        <p className="text-xs font-medium text-slate-500">
          Ties go to fewer guesses, then the faster time. Your first round each day is the one that counts.
        </p>
      </div>
    </div>
  );
}
